import { DEFAULT_DATE_FORMAT } from './constants';
export var TimeValidator = function TimeValidator(momentGenerator) {
  var _this = this;
  this.momentUtils = void 0;
  this.isSameTime = function (date1, date2) {
    if (!date1 || !date2) {
      return date1 === date2;
    }
    var isSame = _this.momentUtils.isSame;
    if (Object.getPrototypeOf(date1) === Object.getPrototypeOf(date2)) {
      if (date1 instanceof Array && date2 instanceof Array) {
        return isSame(date1[0], date2[0], 'second') && isSame(date1[1], date2[1], 'second');
      } else if (date1 instanceof Date && date2 instanceof Date) {
        return isSame(date1, date2, 'second');
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  this.isValidTimeByRule = function (args) {
    var time = args.time,
      minTime = args.minTime,
      maxTime = args.maxTime;
    var _this$momentUtils = _this.momentUtils,
      getHour = _this$momentUtils.getHour,
      getMinute = _this$momentUtils.getMinute;
    var hour = getHour(time);
    var minute = getMinute(time);
    var minHour = getHour(minTime);
    var minMinute = getMinute(minTime);
    var maxHour = getHour(maxTime);
    var maxMinute = getMinute(maxTime);
    return hour >= minHour && hour <= maxHour && minute >= minMinute && minute <= maxMinute;
  };
  this.momentUtils = momentGenerator(DEFAULT_DATE_FORMAT);
};